module.exports = __webpack_public_path__ + "img/page9img7.32c12b12.png";